<template>
  <el-main>
    <!-- 類型選擇 -->
    <div>
      <el-radio-group v-model="nowCategoryId" size="medium">
        <el-radio-button
          v-for="item in categoryList"
          :key="item.name"
          :label="item.id"
          >{{ item.category }}</el-radio-button
        >
      </el-radio-group>
    </div>
    <!-- 間隔 -->
    <br />
    <!-- data1 add btn -->
    <el-button
      v-if="categoryList.length > 0"
      type="primary"
      @click="data1.addForm1.dialogVisible = true"
      >新增 +
    </el-button>
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table
      :data="
        data1.data.slice((currentPage - 1) * pagesize, currentPage * pagesize)
      "
      style="width: 100%"
    >
      <el-table-column label="編號" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="日期" width="100">
        <template slot-scope="scope">
          {{ scope.row.date.substring(0, 10).replace(/-/g, '/') }}
        </template>
      </el-table-column>
      <el-table-column label="課程連結">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{ scope.row.title }}</a>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)"
            >編輯</el-button
          >
          <el-button @click="data1Delete(scope.$index)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1000000]"
        :page-size="pagesize"
        layout="total, sizes,prev, pager, next"
        :total="data1.data.length"
        prev-text="上一頁"
        next-text="下一頁"
      >
      </el-pagination>
    </div>

    <!-- data1 add1 dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data1.addForm1.dialogVisible"
      width="40%"
      @closed="data1AddForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="下架日期" prop="date">
          <el-date-picker
            v-model="data1.addForm1.data.date"
            type="date"
            value-format="yyyy/MM/dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="標題" prop="title">
          <el-input
            type="text"
            v-model.trim="data1.addForm1.data.title"
            autocomplete="off"
            maxlength="300"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="連結"
          prop="url"
          :rules="[
            {
              required: true,
              validator: data1AddForm1ValidUrl,
              trigger: 'blur',
            },
            // { required: true, message: '請輸入連結', trigger: 'blur' },
          ]"
        >
          <el-input
            type="text"
            v-model.trim="data1.addForm1.data.url"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.addForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.addForm1.errorMessage }}
          </el-alert>
        </el-form-item>

        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1AddForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update1 dialog -->
    <el-dialog
      title="編輯"
      :visible.sync="data1.updateForm1.dialogVisible"
      width="40%"
      @closed="data1UpdateForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="data1.updateForm1.data.date"
            type="date"
            value-format="yyyy/MM/dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="標題" prop="title">
          <el-input
            type="text"
            v-model.trim="data1.updateForm1.data.title"
            autocomplete="off"
            maxlength="300"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="連結"
          prop="url"
          :rules="[
            {
              required: true,
              validator: data1UpdateForm1ValidUrl,
              trigger: 'blur',
            },
            // { required: true, message: '請輸入連結', trigger: 'blur' },
          ]"
        >
          <el-input
            type="text"
            v-model.trim="data1.updateForm1.data.url"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.updateForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1UpdateForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  C_CourseCategory_GetList,
  C_Course_Add,
  C_Course_GetList,
  C_Course_Update,
  C_Course_Delete,
} from '@/assets/js/api';

export default {
  data() {
    return {
      editorOption: {
        modules: {
          imageResize: {
            // 添加
            displayStyles: {
              // 添加
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'], // 添加
          },
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'image'],
            ['formula', 'clean'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            // [{ font: fonts }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ direction: 'rtl' }],
          ],
        },
        placeholder: '請輸入内容........',
      },
      currentPage: 1, // 默認顯示第一頁
      pagesize: 1000000, //    每頁顯示筆數
      nowCategoryId: 1,
      categoryList: [],
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            categoryId: '',
            date: '',
            title: '',
            url: '',
          },
          rules: {
            date: [{ required: true, message: '請輸入日期' }],
            title: [
              { required: true, message: '請輸入消息內容' },
              { min: 1, max: 100, message: '標題必須在100個字元內' },
            ],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            date: '',
            title: '',
            url: '',
          },
          rules: {
            date: [{ required: true, message: '請輸入日期' }],
            title: [
              { required: true, message: '請輸入消息內容' },
              { min: 1, max: 300, message: '標題必須在300個字元內' },
            ],
          },
        },
      },
    };
  },
  mounted() {
    C_CourseCategory_GetList()
      .then((res) => {
        this.categoryList = res.data.data;
        if (this.categoryList.length > 0) {
          this.nowCategoryId = this.categoryList[0].id;
        }
      })
      .catch((err) => {
        this.$notify.error({
          title: '錯誤',
          message: err.response.data.message,
        });
      });

    this.data1GetList();
  },
  watch: {
    $route() {},
    nowCategoryId() {
      this.data1GetList();
    },
  },
  methods: {
    handleSizeChange(size) {
      this.pagesize = size;
      /* console.log(this.pagesize) */
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      /* console.log(this.currentPage) */
    },
    // 驗證，特殊處理在form內使用v-if造成的bug，改使用v-show，並使用下列的判斷。
    // eslint-disable-next-line no-unused-vars
    data1AddForm1ValidUrl(rule, value, callback) {
      if (value === '') {
        callback(new Error('請輸入連結'));
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1UpdateForm1ValidUrl(rule, value, callback) {
      if (value === '') {
        callback(new Error('請輸入連結'));
      }
      callback();
    },

    // data1 get list
    data1GetList() {
      C_Course_GetList(this.nowCategoryId)
        .then((res) => {
          this.data1.data = res.data.data;
          for (let i = 0; i < res.data.data.length; i += 1) {
            this.data1.data[i].date = res.data.data[i].date
              .substring(0, 10)
              .replace(/-/g, '/');
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    // data1 add1
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = '';
          this.data1.addForm1.data.categoryId = this.nowCategoryId;
          C_Course_Add(this.data1.addForm1.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.errorMessage = err.response.data.message;
              this.data1.addForm1.loading = false;
            });
        }
      });
    },
    // data1 update1
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;

      this.data1.updateForm1.data.date = thisData.date;
      this.data1.updateForm1.data.title = thisData.title;
      this.data1.updateForm1.data.url = thisData.url;
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          C_Course_Update(
            this.data1.updateForm1.updateId,
            this.data1.updateForm1.data,
          )
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          C_Course_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.top-div {
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  box-sizing: border-box;
  border-radius: 4px;

  color: #409eff;
}
.pagination {
  margin: 10px 0 0 0;
  text-align: center;
}
</style>
